import React from 'react'
import { inject, observer } from 'mobx-react'
import { CreateChildProduct } from '../ProductStore'
import { CurrentCompanyStore } from '../../../../../stores/CurrentCompanyStore'
import { Description } from '../Components/Description'
import { ResponsiveRow } from '../../../../../components/ResponsiveContainer/ResponsiveRow'
import { ColProps } from 'antd-v4/lib/grid'

interface Props {
  currentCompanyStore?: CurrentCompanyStore
  childProduct: CreateChildProduct
}

@inject('currentCompanyStore')
@observer
export class DescriptionTab extends React.Component<Props> {
  render() {
    const { childProduct } = this.props
    const rowProps = { style: { marginBottom: 16 } }
    const labelColProps: ColProps = { md: 18, lg: 8 }
    const contentColProps: ColProps = { md: 16, lg: 16 }

    return (
      <>
        <ResponsiveRow
          labelText={
            <div>
              <strong>Receipt description</strong>
              <div className='text-muted'>Optional, will print on receipts</div>
            </div>
          }
          rowProps={rowProps}
          labelColProps={labelColProps}
          contentColProps={contentColProps}
        >
          <Description
            rows={1}
            value={childProduct.shortDescription || ''}
            disabled={childProduct.parentProduct.isDeleted}
            onChange={(description) => childProduct.setShortDescription(description)}
          />
        </ResponsiveRow>

        <ResponsiveRow
          labelText={<strong>Description</strong>}
          rowProps={rowProps}
          labelColProps={labelColProps}
          contentColProps={contentColProps}
        >
          <Description
            rows={3}
            value={childProduct.description || ''}
            disabled={childProduct.parentProduct.isDeleted}
            onChange={(description) => childProduct.setDescription(description)}
          />
        </ResponsiveRow>
      </>
    )
  }
}
